import { lazy } from 'react';

// Lazy load heavy components
export const MediumArticles = lazy(() => import('../components/MediumArticles'));
export const SuperPancakeShowcase = lazy(() => import('../components/SuperPancakeShowcase'));
export const Testimonials = lazy(() => import('../components/Testimonials'));
export const GitHubNPMStats = lazy(() => import('../components/GitHubNPMStats'));
export const SearchFilter = lazy(() => import('../components/SearchFilter'));
export const VideoDemos = lazy(() => import('../components/VideoDemos'));
export const Projects = lazy(() => import('../components/Projects'));
export const Products = lazy(() => import('../components/Products'));
export const NPMPackages = lazy(() => import('../components/NPMPackages'));
export const BrowserExtensions = lazy(() => import('../components/BrowserExtensions'));
export const AppsAndHobbies = lazy(() => import('../components/AppsAndHobbies'));
export const Skills = lazy(() => import('../components/Skills'));
export const Hobbies = lazy(() => import('../components/Hobbies'));
export const Experience = lazy(() => import('../components/Experience'));
export const Contact = lazy(() => import('../components/Contact'));
export const Profile = lazy(() => import('../components/Profile'));
export const ProfilePage = lazy(() => import('../components/ProfilePage'));
export const Channels = lazy(() => import('../components/Channels'));
export const ChannelPage = lazy(() => import('../components/ChannelPage'));
export const Motocross = lazy(() => import('../components/Motocross'));
export const Footer = lazy(() => import('../components/Footer'));
export const About = lazy(() => import('../components/About'));

